import { useEffect, useState } from "react";
import Container from "../../components/Container";
import pb from "../../lib/pocketbase";
import { Link } from "react-router-dom";
import { config } from "../../config";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";
import { Helmet } from "react-helmet";
import { IDailyRecord } from "../../lib/types";
import { fullDate } from "../../lib/utils";
import Button from "../../components/form/button";
import { useFontAwesomeIconPack } from "../../hooks/useFontAwesomeIconPack";

export default function Profile() {
    const today = new Date();
    const icons = useFontAwesomeIconPack();

    const [todos, setTodos] = useState<IDailyRecord[]>([]);

    async function load() {
        const records: IDailyRecord[] = await pb.collection("daily").getFullList({
            sort: "created"
        });
        setTodos(records);
    }

    useEffect(() => {
        load();
    }, []);

    if (pb.authStore.isValid) {
        let banner = `${config.base}/images/default_banner.jpg`;
        if (pb.authStore.model?.banner) banner = `${config.pocketbase}/api/files/_pb_users_auth_/${pb.authStore.model?.id}/${pb.authStore.model?.banner}`;
        const avatar = `${config.pocketbase}/api/files/_pb_users_auth_/${pb.authStore.model?.id}/${pb.authStore.model?.avatar}`;
        return (
            <div>
                <Helmet>
                    <title>ReinVB Studio</title>
                </Helmet>
                <img src={banner} alt="" className="h-48 w-full border-b-4 object-cover md:h-56 lg:h-64" />
                <Container>
                    <Avatar className="-mt-32 h-36 w-36 rounded-full border-4 object-cover lg:h-48 lg:w-48">
                        <AvatarImage src={avatar} className="object-cover" />
                        <AvatarFallback>{pb.authStore.model?.username.substring(0, 1)}</AvatarFallback>
                    </Avatar>
                    <h1 className="mt-8 text-4xl font-bold">{pb.authStore.model?.name}</h1>

                    <div className="my-16 grid gap-3 lg:grid-cols-2">
                        <Link to="/studio/daily">
                            <Button variant={"ghost"} size="ghost" className="flex w-full flex-col rounded-xl border p-8 text-center shadow">
                                <h3 className="mb-4 text-2xl font-bold">Today</h3>
                                <p>
                                    You got <span className="text-slage-950 font-black dark:text-slate-50">{todos.filter((x) => x.date === fullDate(today) && !x.completed).length}</span> more things to do today.
                                </p>
                            </Button>
                        </Link>
                    </div>
                </Container>
            </div>
        );
    } else return <></>;
}
